<template>
  <anchor-link
    :href="href"
    is-target-blank
    class="link"
  >
    <span class="link__text">{{ title }}</span>
    <icon-new-window class="link__icon"/>
  </anchor-link>
</template>

<script>
import { titledLinkProps } from '@/mikan/_shared/types/vueTypes/anchorLink';
import IconNewWindow from '@/mikan/_shared/components/atoms/icons/IconNewWindow.vue';
import AnchorLink from '@/mikan/_shared/components/atoms/AnchorLink.vue';

export default {
  components: {
    AnchorLink,
    IconNewWindow,
  },
  props: {
    ...titledLinkProps,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/pc/base/constants';

.link {
  display: inline-flex;
  align-items: center;
  color: $color-text-link;
  line-height: 1.2;
  transition: color $transition-interaction;

  &:hover {
    color: $color-text-link-hover;
  }

  &__text {
    flex: 0 0 auto;
    line-height: 1;
  }

  &__icon {
    display: block;
    flex: 0 0 auto;
    margin-left: px-to-em(6px);
    font-size: px-to-em(10px);
  }
}
</style>
